<div class="title-and-link">
  <h2 class="list-subtitle">ABOUT LISTS</h2>
  <button
    class="btn btn-link"
    *ngIf="!expandedView"
    (click)="expandedView = true"
  >
    Show more
    <img
      [src]="'../../assets/images/show_more_gray600.png'"
      class="toggle-show-image"
    />
  </button>
  <button
    class="btn btn-link"
    *ngIf="expandedView"
    (click)="expandedView = false"
  >
    Show less
    <img
      [src]="'../../assets/images/show_less_gray600.png'"
      class="toggle-show-image"
    />
  </button>
</div>
<div *ngIf="expandedView">
  <h2 class="sublist-title">GROUP</h2>
  <p class="sublist-desc">
    A Group is a list of specific students. Criteria may be attached in order to
    track the progress of an intervention and evaluate if students meet or do
    not meet criteria. Students not in the group who meet the metric criteria
    will also be recommended.
  </p>
  <h2 class="sublist-title">VIEW</h2>
  <p class="sublist-desc">
    A view is set of metric filters and sort criteria. The list of students
    shown dynamically changes to meet the criteria. Use views to identify
    students for intervention or support.
  </p>
</div>
